import React, { useEffect } from 'react'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import constants from "../../pages/AvailabilityForm/constants";
import "./style.css";

const Time = ({
  deltaPosition,
  setzmTxt,
  setExpertDayOffset = null,
  setClientDayOffset = null
}) => {
  const {
    state
  } = useStore();
  const {
    expertZone,
    clientZone,
    duration
  } = state;
  const {
    time
  } = constants;
  const timeArr = time.concat(time).concat(time).concat(time).concat(time);
  const day = timeArr.map((x, i) => {
    if (i < 96) {
      return `-1`;
    } else if (i > 191) {
      return `+1`;
    } else {
      return '';
    }
  });
  const startIndex = Math.round(deltaPosition.y / 5.75 + 96);
  const endIndex = startIndex + duration / 15;
  const tz = clientZone.timezoneOffset / 15;
  const tzx = expertZone.timezoneOffset / 15;
  const tzOps = new Date().getTimezoneOffset() / 15;
  let result = `${timeArr[startIndex + tzOps + tz]} - ${timeArr[endIndex] === undefined ? '00:00' : timeArr[endIndex + tzOps + tz]}`;
  let resultx = `${timeArr[startIndex + tzOps + tzx]} - ${timeArr[endIndex] === undefined ? '00:00' : timeArr[endIndex + tzOps + tzx]}`;
  let resultOps = `${timeArr[startIndex]} - ${timeArr[endIndex] === undefined ? '00:00' : timeArr[endIndex]}`;
  useEffect(() => {
    setzmTxt(resultOps);
  }, [resultOps, setzmTxt]);
  return /*#__PURE__*/React.createElement("div", {
    className: "showTime timeContainer"
  }, /*#__PURE__*/React.createElement("p", {
    className: "timeTarget",
    id: "timeTarget"
  }, `${result} `, /*#__PURE__*/React.createElement("span", {
    className: "nextOrPrevDay"
  }, `${day[startIndex + tzOps + tz]}`)), /*#__PURE__*/React.createElement("p", {
    id: "opsTime",
    className: "opsTime"
  }, `${resultOps} `), /*#__PURE__*/React.createElement("p", {
    className: "resultx"
  }, /*#__PURE__*/React.createElement("span", {
    className: "nextOrPrevDay"
  }, `${day[startIndex + tzOps + tzx]}`), ' ', `${resultx}`));
};

export default Time;